///<reference path="../paymentPlans.module.ts"/>
///<reference path="../../../../../typings/index.d.ts"/>

module Meevo.Plugins.PaymentPlans {
    export function payPlanPaymentStatusFilter(paymentPlansHelper: PaymentPlansHelper): any {
        const filter = (input: Meevo.Plugins.EftControlPanel.EPaymentPlanBillStatusEnum) => {
            return paymentPlansHelper.payPlanPaymentStatusVerbose(input);
        };

        filter.$inject = ['meevo.plugins.paymentPlans.PaymentPlansHelper'];

        return filter;
    }

    angular.module('meevo.plugins.paymentPlans')
        .filter('payPlanPaymentStatusFilter', payPlanPaymentStatusFilter);
}
